<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let value;
    export let id;

    const dispatch = createEventDispatcher();

    const onChange = () => {
        dispatch("change", value);
    }
</script>
<input type="tel" class="form-control" {id} bind:value="{ value }"
       oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');">